import React from 'react';
import { PropTypes } from 'prop-types';
import LoadingArea from '@molecules/LoadingArea';
import PropertyCard from '@molecules/PropertyCard';
import PagedRecords from '@organisms/PagedRecords';
import { mapGraphPropertyToProps } from '@general/transforms/property.transform';
import useSavedProperties from '../../../hooks/useSavedProperties';

const PropertyCardsPaged = ({ properties, showShareIcon, onPropertyClick = () => {} }) => {
    const { data: savedProperties } = useSavedProperties();

    if (!properties || !savedProperties) {
        return <LoadingArea />;
    }

    if (properties.length === 0) {
        return null;
    }

    const renderCards = records =>
        records.map(record => {
            const props = {
                ...mapGraphPropertyToProps(record),
                isFavorite: !!savedProperties.find(savedProperty => savedProperty.recordId === record.recordId),
            };
            return (
                <div className="d-flex flex-column mb-4 col-md-4" key={`property-card-${record.id}`}>
                    <PropertyCard {...props} showShareIcon={showShareIcon} onClick={hit => onPropertyClick(hit)} />
                </div>
            );
        });

    return (
        <PagedRecords records={properties.filter(property => property !== null)} recordsPerPage={3}>
            {records => <div className="row">{renderCards(records)}</div>}
        </PagedRecords>
    );
};

PropertyCardsPaged.propTypes = {
    properties: PropTypes.array,
    showShareIcon: PropTypes.bool,
    onPropertyClick: PropTypes.func,
};

export default PropertyCardsPaged;
